<script>  
  let data = [
    {x: 4, r: 25, fill:'transparent', stroke: '#000', text: '20 Tril' },
    {x: 16, r: 14, fill:'transparent', stroke: '#000', text: '50 Bil'},
    {x: 25, r: 4, fill:'transparent', stroke: '#000', text: '500 Mil'},
  ]
  </script>
  
  <figure class="interactive__size-legend legend">
    <figcaption class="legend__title">GDP</figcaption>
    <svg class="legend__size-circles">
      {#each data as d, legendIndex}
        <circle 
          cx="10%" 
          cy={28 + d.x + "px"} 
          r={d.r} 
          fill={d.fill} 
          stroke={d.stroke} 
          region={d.region} 
          data-color={d.text}
        />
        <text class="legend__labels" x="25%" y={15 + (legendIndex * 21) + "px"}>{d.text}</text>
        <line x1="30" x2="70" y1={28 + d.x - d.r + "px"} y2={28 + d.x - d.r + "px"}></line>
      {/each}
    </svg>
  </figure>
  
  <style type="text/scss" global>
    @import "../scss/custom/legend.scss";
  </style>